export default "__VITE_ASSET__DBrIrPtF__"